export const avatar_conductor = require("./assets/avatars/avatar-conductor.png");
export const avatar_blue = require("./assets/avatars/avatar-blue.png");
export const avatar_green = require("./assets/avatars/avatar-green.png");
export const avatar_orange = require("./assets/avatars/avatar-orange.png");
export const avatar_pink = require("./assets/avatars/avatar-pink.png");
export const avatar_purple = require("./assets/avatars/avatar-purple.png");
export const avatar_red = require("./assets/avatars/avatar-red.png");
export const avatar_yellow = require("./assets/avatars/avatar-yellow.png");